<div class="flex-container">
  <div class="container">
    <app-filters
      class="filters"
      (filtersChanged)="filtersChanged($event)"
    ></app-filters>
    <app-details class="tabs"></app-details>
  </div>
</div>
